import React, {Component, ReactElement} from 'react'
import {BlockSpacer} from '../../../../styledComponents/ResponsiveConvenience'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet,
} from '../../../../components/shared/hoc/createResidentWithErrorHandlingPage'
import {Box} from '@mui/material'
import {ColumnFlexContainer} from '../../../../styledComponents/FlexComponents'
import styled from 'styled-components'
import {Colors, FontSize, FontWeights} from '../../../../styledComponents/Constants'
import {CenterPlainLinkStyledButton, StyledSecondaryButton} from '../../../../styledComponents/Button'

interface Props {
    condominiumCd: string
}

class NatResidentApplicationCompletePage extends Component<Props & ResidentWithErrorHandlingPagePropsSet> {

    constructor(props: Readonly<Props & ResidentWithErrorHandlingPagePropsSet>) {
        super(props)

        this.handleBackApplicationList = this.handleBackApplicationList.bind(this)

        this.handleApplicationHistory = this.handleApplicationHistory.bind(this)
    }

    handleApplicationHistory(): void {
        const {navigate, condominiumCd} = this.props

        navigate(`/resident/condominiums/${condominiumCd}/applications/history`, {replace: true})
    }

    handleBackApplicationList(): void {
        const {navigate, condominiumCd} = this.props

        navigate(`/resident/condominiums/${condominiumCd}/applications`, {replace: true})
    }

    render(): ReactElement {
        return (<>
            <ColumnFlexContainer>
                <BlockSpacer height={'60px'}/>
                <img src={'/resources/images/icons/icon_reserve_complete.svg'} width={'120px'} alt={'complete'}/>
                <BlockSpacer height={'20px'}/>
                <CompleteMessage>申請を提出しました</CompleteMessage>
                <Box height={'5px'}/>
                <CompleteMessageSub>提出完了メールが届きます。<br/>
                    メールが届かない場合は、正しいメールアドレスが登録されているか個人設定メニューからご確認ください。</CompleteMessageSub>
                <Box height={'5px'}/>
                <ContactMessageBox>
                    <ContactMessageTitle>申請結果のご連絡をお待ちください</ContactMessageTitle>
                    申請内容を確認後、メールにて結果をお知らせします。
                    確認にはお時間をいただく場合がございます。
                </ContactMessageBox>
            </ColumnFlexContainer>
            <BlockSpacer height={'30px'}/>
            <StyledSecondaryButton onClick={this.handleApplicationHistory}>
                申請履歴を見る
            </StyledSecondaryButton>
            <BlockSpacer height={'30px'}/>
            <CenterPlainLinkStyledButton onClick={this.handleBackApplicationList}>
                届出・申請へ
            </CenterPlainLinkStyledButton>
            <BlockSpacer height={'15px'}/>
        </>)
    }
}

export default createResidentWithErrorHandlingPage(NatResidentApplicationCompletePage)

const CompleteMessage = styled.div`
  font-size: ${FontSize.Big};
  font-weight: ${FontWeights.Bold};
  color: ${Colors.AccentDark};
`
const CompleteMessageSub = styled.div`
  font-size: ${FontSize.Small};
  text-align: center;
`
const ContactMessageBox = styled.div`
  font-size: ${FontSize.Middle};
  width: 350px;
  border: 1px solid #F5A623;
  padding: 8px;
  margin: 10px 0 10px 0;
  background-color: #F5A62333;
`
const ContactMessageTitle = styled.div`
  margin-bottom: 10px;
  font-weight: ${FontWeights.Bold};
`
